import { createApp } from "vue";
import App from "./Contact.vue";
import SpeechPlugin from "../../../../plugins/speech";
import "primevue/resources/primevue.min.css";
import "primeflex/primeflex.css";
import "primevue/resources/themes/nova/theme.css";
import "primeicons/primeicons.css";

const app = createApp(App);
app.use(SpeechPlugin);
app.mount("#app");
